
/**
 * Capitaliza cada palabra en una cadena dada.
 * Convierte toda la cadena a minúsculas y luego pone en mayúscula la primera letra de cada palabra.
 *
 * @param str - Cadena de texto a capitalizar.
 * @returns La cadena con cada palabra capitalizada.
 */
export const capitalizeString = (str: string): string => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}